import styled from 'styled-components';
import theme from 'v3/theme';

export const AnsweredBanner = styled.div`
  background: ${theme.colors.light_green};
  border: 1px solid ${theme.colors.success};
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
`;
